export const allLangs = [{
  // 命名保持和 给server传递的值一致
  locale: 'zh',
  name: '简体中文',
  source: require('./zh-cn').default,
},
{
  // 命名保持和 给server传递的值一致
  locale: 'zh-TW',
  name: '繁體中文',
  source: require('./zh-tw').default,
},
{
  // 命名保持和 给server传递的值一致
  locale: 'en',
  name: 'English',
  source: require('./en-us').default,
},
];

export const langsMessage = (function () {
  const langMsg: {[key: string]: any} = {};
  allLangs.forEach((item) => {
    langMsg[item.locale] = item.source;
  });
  return langMsg;
}());

// 国际化语言包管理
import Vue from 'vue';
// 注意这里要安装8.x版本，否则会报错。
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// storage key
const KEY_LOCALE = 'qdim-locale';

const i18n = new VueI18n({
  locale: getLangLocale(langsMessage),
  messages: langsMessage,
});

// 获得语言配置
function getLangLocale(langs: any): string {
  // 读取缓存语音设置
  try {
    const locale = localStorage && localStorage.getItem(KEY_LOCALE);
    if (locale && (locale in langs)) {
      return locale;
    }
  } catch (ex) {};
  // 默认简体中文
  return allLangs[0].locale;
}

// 设置语言 并缓存
function setLangLocale(locale: string): void {
  try {
    // 检查是否支持该语言
    if (!(locale in langsMessage)) {
      console.error(`locale '${locale}' is not exist!`);
      return;
    }

    i18n.locale = locale;

    // 缓存语言设置
    localStorage.setItem(KEY_LOCALE, locale);
  } catch (ex) {
    console.log(ex);
  }
}

// 获得语言列表
function getAllLocales(): any {
  return allLangs.map((item) => {
    const newItem = { ...item };
    delete newItem.source;
    return newItem;
  });
}

// i18n
// Vue.prototype.$i18n = i18n;
// bind 'this' ; 设置语言
Vue.prototype.$setLocale = setLangLocale;
// 获得所有支持的语言列表
Vue.prototype.$getAllLocales = getAllLocales;

export default i18n;
